<xi-generic-modal
  [canBackdropClose]="false"
  [customPadding]="{ top: '0', right: '0', bottom: '0', left: '0' }"
  [isVisible]="true"
  maxWidth="800px"
  (onClose)="cancel()"
>
  <div slot="children">
    <xi-basic-tile [hasTopBar]="false" [stretch]="true" [isInteractive]="false">
      <div slot="children" *transloco="let t; read: 'collection-advanced-options-dialog'">
        <div class="xi-modal__container advanced-options__container">
          <div class="xi-modal__title">
            <div class="kxi-text-xlarge kxi-text-600">{{ t('advanced-upload-options') }}</div>
            <h3 class="grey">{{ t('specify-additional-upload') }}</h3>
          </div>

          <div class="advanced-options__input-fields">
            <form autocomplete="off" [formGroup]="form">
              <label for="rows-to-skip" class="kxi-text-small">{{ t('rows-to-skip') }}</label>
              <div class="xi-input-field-wrapper">
                <xi-input-field
                  id="rows-to-kip"
                  (onInputEnter)="save()"
                  [status]="toSkipStatus"
                  formControlName="toSkip"
                  placeholder="{{ t('number') }}"
                  appAutoFocus="xiInput"
                  type="number"
                  [min]="0"
                  appOnlyDigit
                >
                </xi-input-field>
              </div>
              <label for="rows-to-upload" class="kxi-text-small">{{ t('rows-to-upload') }}</label>
              <div class="xi-input-field-wrapper">
                <xi-input-field
                  id="rows-to-upload"
                  (onInputEnter)="save()"
                  [status]="toUploadStatus"
                  formControlName="toUpload"
                  [placeholder]="t('number')"
                  type="number"
                  [min]="0"
                  appOnlyDigit
                >
                </xi-input-field>
              </div>
            </form>
          </div>

          <div class="xi-modal__actions">
            <xi-default-button
              [text]="t('cancel')"
              fill="text"
              (onClick)="cancel()"
            ></xi-default-button>

            <xi-default-button
              [text]="t('save')"
              [disabled]="
                !!this.form.controls.toSkip.errors || !!this.form.controls.toUpload.errors
              "
              (onClick)="save()"
            ></xi-default-button>
          </div>
        </div>
      </div>
    </xi-basic-tile>
  </div>
</xi-generic-modal>
